import styled from 'styled-components';

export const MainContainerRow = styled.div`
  display: flex;
  height: 520px;
  flex-direction: row;
  justify-content: center;
  background: #002060;
`;

export const MainContainerCol = styled.div`
  align-items: center;
  background: none;
  display: flex;
  flex-direction: column;
  max-height: 520px;
  position: absolute;
  top: 100px;
  z-index: 10;
`;

export const AuthWidget = styled.div`
  z-index: 2;
  #okta-sign-in {
    margin: 0px;
    h2 {
      color: #16709e;
      font-size: 1.5rem;
      font-weight: 700;
      font-family: montserrat, Arial, Helvetica, sans-serif;
      line-height: 1.5;
      margin-top: 10px;
    }
  }
`;

export const RegisterContainerHeader = styled.div`
  padding: 20px 90px;
  border-bottom: 1px solid #ddd;
`;

export const RegisterContainerBody = styled.div`
  text-align: start;
  .advice-text {
    font-size: 0.8rem;
    a {
      font-weight: bold;
      color: #16709e;
    }
  }
`;

export const ImageContainer = styled.div`
  background-image: url('background.png');
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left;
  position: absolute;
  top: 0;
  opacity: 0.5;
  z-index: 1;
  width: 100%;
  height: 520px;
  min-height: 520px;
  overflow-y: hidden;
`;

export const SkyanName = styled.div`
  text-align: center;
  color: white;
  font-size: 50px;
  font-weight: bold;
  z-index: 2;
`;

export const RegisterContainer = styled.div`
  z-index: 2;
  text-align: center;
  background-color: #fff;
  border: solid #d8d8d8;
  box-shadow: 0 2px 0 hsl(0deg 0% 69% / 12%);
  border-radius: 0.5rem;
  width: 400px;
  padding: 1rem 2rem;
  .form-label {
    color: #16709e;
    font-weight: 700;
    margin-top: 0.5rem;
  }
  .nepc-captcha {
    margin-bottom: 8px;
    text-align: center;
    text-align: -webkit-center;
  }
  h2 {
    color: #16709e;
    font-size: 1.5rem;
    text-align: center;
    font-weight: 700;
    font-family: montserrat, Arial, Helvetica, sans-serif;
    line-height: 1.5;
    margin-top: 10px;
  }
  .authContainer-btn {
    color: #fff;
    background-color: #16709e;
    border-color: #16709e;
    display: block;
    width: 100%;
    height: 3em;
    font-family: Open Sans, sans-serif !important;
    font-size: 1.125rem !important;
    font-weight: 700;
    border-radius: 0;
    margin: auto;
    background-image: none;
    &:disabled {
      color: #fff;
      background-color: #16709e;
      border-color: #16709e;
    }
  }
`;

export const TermsLink = styled.div`
  width: 400px;
  margin: auto;
  margin-top: -0.5em;
  padding-bottom: 2rem;
  font-size: 0.8em;
  padding-top: 0;
  justify-items: right;
  z-index: 1;
  .nav-link {
    padding-right: 1rem;
    padding-top: 0.5rem;
    color: white;
    font-weight: bold;
    width: 13em;
  }
`;
